// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".service-container[data-v-06b9817e] {\n  width: 100%;\n  max-width: none;\n}", ""]);
// Exports
module.exports = exports;
